module.exports = __webpack_public_path__ + "46e7ca8f952510bbde5603f07fd5d06e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product-default-image.jpg
// module id = 44
// module chunks = 1